import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { communicationPreferencesSaga } from '../individual-portal-sagas/communication-preferences-saga';
import { communicationPreferencesSagaActionTypes } from '@constants/actionTypes/dashboardActionTypes';

const {
    FETCH_COMMUNICATION_PREFERENCES
} = communicationPreferencesSagaActionTypes;

export default function* ():  Generator<ForkEffect<never>, void> {
    yield takeEvery(FETCH_COMMUNICATION_PREFERENCES, communicationPreferencesSaga);
}